import API from '@utils/api.ts';
import { API_URL } from '@app/constants/APIKEYS';

/**
 * 북마크 조회 API
 * GET /bookmark
 */
export const getBookmarks = async (token: string) => {
  try {
    const response = await API.get('/bookmark', token, {});
    return response;
  } catch (error) {
    console.error('❌ 북마크 조회 에러:', error);
    throw error;
  }
};

/**
 * 북마크 추가 API
 * POST /bookmark
 */
export const addBookmark = async (token: string, ep_id: number) => {
  try {
    const response = await API.post('/bookmark', token, { ep_id });
    return response;
  } catch (error) {
    console.error('❌ 북마크 추가 에러:', error);
    throw error;
  }
};

/**
 * 북마크 삭제 API
 * DELETE /bookmark/{ep_id}
 */
export const removeBookmark = async (token: string, ep_id: number) => {
  try {
    const url = `/bookmark/${ep_id}`;
    const fullUrl = API_URL + url;
    
    const response = await API.delete(url, token, {});
    return response;
  } catch (error) {
    console.error('❌ 북마크 삭제 에러:', error);
    throw error;
  }
};

/**
 * 북마크 순서 변경 API
 * PUT /v1/bookmark/order
 */
export const updateBookmarkOrder = async (token: string, bookmarks: Array<{ id: number; sort_order: number }>) => {
  try {
    const response = await API.put('/bookmark/order', token, { bookmarks });
    return response;
  } catch (error) {
    console.error('❌ 북마크 순서 변경 에러:', error);
    throw error;
  }
}; 